module.exports = __webpack_public_path__ + "media/images/home/fb_logo-abd92a325ca9c5eb0bf46f1d491567b3.png";